<template>
  <div class="RwvBookMeta">
    <!-- <router-link
      :to="{ name: 'profile', params: { username: post.author.username } }"
    > -->
    <router-link
      v-if="post.author.image"
      class="avatar-image"
      :to='{name: "author", params: {slug: post.author.slug}}'>
      <!-- <img :src="post.author.image" /> -->
      <img :src="post.author.image"/>
    </router-link>
    <div class="info">

      <!-- <router-link :to='{name: "post-edit", params: {slug: post.slug}}'>
      </router-link> -->
      <!-- <router-link
        :to="{ name: 'profile', params: { username: post.author.username } }"
        class="author"
      > -->

      <router-link
        :to='{name: "author", params: {slug: post.author.slug}}'
        class="author"
        v-bind:class="{ lightTheme: isLightTheme, darkTheme: !isLightTheme }">
        {{post.author.name.title + " " + post.author.name.name + " " + post.author.name.surname}}
        <!-- {{ post.author.username }} -->
      </router-link>

      <span v-if="!isBook" class="date">{{ post.published.year}}</span>
      <span v-else class="date">{{ post.author.description}}</span>
      <!-- date appears to be a filter -->
      <!-- <span class="date">{{ post.createdAt | date }}</span>  -->
    </div>
    <template v-if="actions && !isBook">
      <rwv-post-actions
        :post="post"
        :isAuthenticated="isAuthenticated"
        :preview="preview"
        :isLightTheme="isLightTheme"
        :isBook="isBook"
        class="actions"
      ></rwv-post-actions>
    </template>
  </div>
</template>

<script>
import RwvPostActions from "@/components/Posts/PostActions";

export default {
  name: "RwvPostMeta",
  components: {
    RwvPostActions
  },
  props: {
    post: {
      type: Object,
      required: true
    },
    actions: {
      type: Boolean,
      required: false,
      default: false
    },
    preview: {
      type: Boolean,
      default: false
    },
    isAuthenticated: {
      type: Boolean,
      default: false
    },
    isBook: {
      type: Boolean,
      required: true
    },
    isLightTheme: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style lang="scss">
.RwvBookMeta {
  margin: 1.5rem 0 0;
  line-height: 1.3rem;
  position: relative;
  font-size: 1rem;
  .avatar-image {
    width: 32px; height: 32px;
    background-color: rgb(131,131,131);
    display:inline-block;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .info {
    display:inline-block;
    vertical-align: middle;
    line-height: 1rem;
    margin: 0 1.5rem 0 .3rem;
    .author {
      display: block;
      font-size: 1rem;
      &.lightTheme {
        color: rgb(2, 45, 237);
        // color: rgb(66, 66, 66);
      }
      &.darkTheme {
        color: #fff;
      }
    }
    .date {
      font-size: 0.8rem;
      display: block;
      color: rgb(150,150,150);
    }
  }
  .actions {
    @media screen and (max-width: $screen-md-min) {
      width: 100%;
      display: block;
    }
  }
}


</style>
